var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-item',{class:_vm.customClass,style:(_vm.customStyle),attrs:{"tag":_vm.tag,"dark":_vm.dark,"dense":_vm.dense}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }